type Document360Queue = {
  (...args: unknown[]): void;
  q?: unknown[][];
};

declare global {
  interface Window {
    Cypress?: unknown;
    "JS-Widget"?: string;
    mw?: Document360Queue;
  }
}

const WIDGET_GLOBAL = "mw";
const WIDGET_SRC = "https://cdn.document360.io/static/js/widget.js";

const createWidgetQueue = (): Document360Queue => {
  const queue: Document360Queue = (...args: unknown[]) => {
    queue.q = queue.q ?? [];
    queue.q.push(args);
  };
  return queue;
};

const initDocument360Widget = (): void => {
  if (window.Cypress) {
    return;
  }

  const queue = window.mw ?? createWidgetQueue();
  window["JS-Widget"] = WIDGET_GLOBAL;
  window.mw = queue;

  const script = document.createElement("script");
  script.id = WIDGET_GLOBAL;
  script.src = WIDGET_SRC;
  script.async = true;
  document.head.appendChild(script);

  queue("init", { apiKey: import.meta.env.VITE_DOC_360_KEY });
};

initDocument360Widget();

export {};
